// extracted by mini-css-extract-plugin
export var border1 = "cH_ht";
export var border2 = "cH_hv";
export var border3 = "cH_hw";
export var border4 = "cH_hx";
export var container = "cH_f";
export var dark = "cH_cC";
export var large = "cH_b2";
export var ldsRing = "cH_hy";
export var light = "cH_cB";
export var medium = "cH_b3";
export var primaryPressed = "cH_hz";
export var xlarge = "cH_hs";